import { call, put, takeLatest, select } from 'redux-saga/effects';
import { apiGetCall, apiPostCall, apiDeleteCall, apiPutCall } from '../api';
import {
  showAPIerror,
  sortUsers
} from '../../pages/SellerProfile/APIs/Helpers';
import {
  getUserIdAndSellerId,
  setSeller_id,
  setUser_id,
  setOnboardingStatus,
  getStatus,
  fecthAllUsers,
  setUsers,
  setIsAdmin,
  setAddUsers,
  setAddUsersSuccess,
  setAddUsersFailure,
  resetSuccess,
  fetchgetIndUser,
  fetchgetIndUserSuccess,
  fetchgetIndUserFailure,
  deleteUserFailure,
  deleteUserStart,
  deleteUserSuccess,
  updateUserFailure,
  updateUserSuccess,
  updateUserStart,
  resetSubmitSuccess,
  resetRemovingSuccess,
  setApiStatus,
  setaddingUserError,
  setShowSuccessPopUp,
  setDispError
  //resetModalState
  //setRemovingSuccess

} from '../slices/sellerProfileSlice';
import { PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import { InteractionRequiredAuthError } from '@azure/msal-browser';

const URL = process.env.REACT_APP_API_BASE;

function* checkTokenExpired() {
  // if (jwtDecode(token).exp < Date.now() / 1000) {
  yield (window.instance as any)
    .acquireTokenSilent({
      redirectUri: process.env.REACT_APP_AZURE_REDIRECT,
      authority: process.env.REACT_APP_AZURE_AUTHORITY
    })
    .then((res) => {
      axios.defaults.headers.common['Authorization'] = `Bearer ${res.idToken}`;
    })
    .catch((e) => {
      if (e instanceof InteractionRequiredAuthError) {
        (window.instance as any).loginRedirect();
      }
    });
}

const getSellerAndUserIDsAPI = async () => await axios.get(URL + '');

function* getSellerAndUserIDsSaga(
  action: PayloadAction<{ seller_id: string; user_id: string }>
) {
  try {
    yield call(checkTokenExpired);
    const response = yield call(getSellerAndUserIDsAPI);
    const seller_id = response.data.seller_id;
    const user_id = response.data.user_id;
    yield put(setSeller_id(seller_id));
    yield put(setUser_id(user_id));
    yield put(setIsAdmin(response.data.role_id === 'USR001' ? true : false));
  } catch (error) {
    const {spPageText} = yield select(({ sellerProfile: { spPageText } }) => ({ spPageText }));
    yield call(showAPIerror, error, spPageText,setShowSuccessPopUp,setApiStatus, 'getSellerAndUserIDs');
  }
}

function* getStatusSaga(action: PayloadAction<{ seller_id: string }>) {
  try {
    yield call(checkTokenExpired);
    const response = yield call(
      apiGetCall,
      URL + 'onboarding-status/' + action.payload.seller_id
    );
    const status = response?.status;

    let countCompleted = 0;
    Object.values(status)?.forEach((v: any) => v && countCompleted++);
    status['completed'] = countCompleted;

    yield put(setOnboardingStatus(status));
  } catch (error) {
    const {spPageText} = yield select(({ sellerProfile: { spPageText } }) => ({ spPageText }));
    yield call(showAPIerror, error, spPageText,setShowSuccessPopUp,setApiStatus, 'getStatus');
  }
}

const getUserListDetailTypes = async () =>
  await axios.get(URL + 'user-list-details');


const convertAdditionalAccess = (user, getUserDetailTypes) => {
  const addAccessArr: any[] = [];
  getUserDetailTypes.data.additional_access.forEach((access: any) => {
    //we need the additional access info in an array, so convert here
    user['additional_access']?.includes(access.additional_access_id) &&
      addAccessArr.push(access.additional_access_id);
  });
  user['additional_access_id'] = addAccessArr;
  return user;
};

function* SpAPIgetAllUsersSaga(
  action: PayloadAction<{ seller_id: string; user_id: string }>
) {
  try {
    const state = yield select(({ sellerProfile: { isAdmin } }) => ({
      isAdmin
    }));

    yield call(checkTokenExpired);
    if (state.isAdmin) {
      yield call(getStatusSaga, action);
    }
    // yield call(getStatusSaga, action);
    const response = yield call(
      apiGetCall,
      URL + 'user-list-contacts/' + action.payload.seller_id + '?offset=0'
    );
    const finalData = response['users'];
    const getUserDetailTypes: any = yield call(getUserListDetailTypes);
    finalData.forEach((user) => {
      convertAdditionalAccess(user, getUserDetailTypes);
    });
    const sortedUsers = sortUsers(finalData);
    yield put(setUsers(sortedUsers));
  } catch (error) {
    const {spPageText} = yield select(({ sellerProfile: { spPageText } }) => ({ spPageText }));
    yield call(showAPIerror, error, spPageText,setShowSuccessPopUp,setApiStatus, 'SpAPIgetAllUsers');
  }
}


const getFormattedUpdates = (updates) => {
  const formattedUpdates = {};
  Object.keys(updates).forEach((key) => {
    updates[key]['content'] &&
      (formattedUpdates[key] = updates[key]['content']);
  });
  return formattedUpdates;
};



function* addUsersSaga(action: PayloadAction<any>) {
  try {
    yield call(checkTokenExpired);
    const { formUpdates } = action.payload;
    const { seller_id, user_id } = yield select(({ sellerProfile: { seller_id, user_id } }) => ({ seller_id, user_id }));
    const updates = getFormattedUpdates(formUpdates['addUser']);
    const response = yield call(apiPostCall, URL + 'user-list-contact/' + seller_id, updates);
    if (response.status === 'successful') {
      yield put(setAddUsersSuccess({ ...response.resp, user_approved: response.user_approved }));
      yield put(fecthAllUsers({ seller_id, user_id }));
      yield put(resetSuccess(true));
    }
  } catch (error: any) {
    const {spPageText} = yield select(({ sellerProfile: { spPageText } }) => ({ spPageText }));
    yield put(setAddUsersFailure(showAPIerror(error, spPageText,setShowSuccessPopUp,setApiStatus, 'addUsersSaga')));
    yield put(setaddingUserError(true));
    yield put(setDispError(error));
  }
}


function* fetchgetIndUserSaga(action) {
  try {
    yield call(checkTokenExpired);
    const { curr_user_id } = yield select(({ notification: { curr_user_id } }) => ({ curr_user_id }));
    const id = curr_user_id || action.payload.user_id;
    const response = yield call(apiGetCall, URL + 'user-list-contact/' + id);
    const finalData = response['user'];
    if (finalData) {
      const getUserDetailTypes: any = yield call(getUserListDetailTypes);
      const cleanedFinalData = finalData.map((user) => {
        return convertAdditionalAccess(user, getUserDetailTypes);
      });
      yield put(fetchgetIndUserSuccess(cleanedFinalData[0]));
    }
  } catch (error) {
    const {spPageText} = yield select(({ sellerProfile: { spPageText } }) => ({ spPageText }));
    yield put(fetchgetIndUserFailure(showAPIerror(error, spPageText,setShowSuccessPopUp,setApiStatus, 'fetchgetIndUserSaga')));
  }
}


function* deleteUserSaga(action) {
  try {
    yield call(checkTokenExpired);
    const { curr_user_id } = yield select(({ notification: { curr_user_id } }) => ({ curr_user_id }));
    const { seller_id, user_id } = yield select(({ sellerProfile: { seller_id, user_id } }) => ({ seller_id, user_id }));
    const response = yield call(apiDeleteCall, URL + 'user-list-contact/' + curr_user_id);
    if (response.status === 'successful') {
      yield put(deleteUserSuccess(response));
      yield put(fecthAllUsers({ seller_id, user_id }));
      yield put(resetRemovingSuccess(true));

    }
  } catch (error) {
    const {spPageText} = yield select(({ sellerProfile: { spPageText } }) => ({ spPageText }));
    yield put(deleteUserFailure(showAPIerror(error, spPageText,setShowSuccessPopUp,setApiStatus, 'deleteUserSaga')));
  }
}


function* updateUserSaga(action) {
  try {
    yield call(checkTokenExpired);
    const { formUpdates } = action.payload;
    const { curr_user_id } = yield select(({ notification: { curr_user_id } }) => ({ curr_user_id }));
    const updates = getFormattedUpdates(formUpdates['editUserProfile']);
    const response = yield call(apiPutCall, URL + 'user-list-contact/' + curr_user_id, updates)
    if (response.status === 'successful') {
      yield put(updateUserSuccess(response));
      yield put(fetchgetIndUser({ curr_user_id }));
      yield put(resetSubmitSuccess(true));
    }
  }
  catch (error) {
    const {spPageText} = yield select(({ sellerProfile: { spPageText } }) => ({ spPageText }));
    yield put(updateUserFailure(showAPIerror(error, spPageText,setShowSuccessPopUp,setApiStatus, 'updateUserSaga')));
  }
}


export default function* sellerProfileSaga() {
  yield takeLatest(getStatus.type, getStatusSaga);
  yield takeLatest(fecthAllUsers.type, SpAPIgetAllUsersSaga);
  yield takeLatest(getUserIdAndSellerId.type, getSellerAndUserIDsSaga);
  yield takeLatest(setAddUsers.type, addUsersSaga);
  yield takeLatest(fetchgetIndUser.type, fetchgetIndUserSaga);
  yield takeLatest(deleteUserStart.type, deleteUserSaga);
  yield takeLatest(updateUserStart.type, updateUserSaga);
}
